import React, { Fragment, useState } from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import styles from './VersionHistoryCard.module.css';
import MenuButton from 'components/MenuButton/MenuButton';
import ModalFactory, { ModalType } from 'components/CustomModal/ModalFactory';
import { ReactComponent as VersionRestoreIcon } from 'assets/images/VersioHistoryIcons/version-restore-icon.svg';
import { ReactComponent as VersionNameIcon } from 'assets/images/VersioHistoryIcons/version-name-icon.svg';
import { ReactComponent as CopyIcon } from 'assets/images/copy-icon.svg';
import { colorPalette } from 'styles/partials/colors';

export interface VersionHistoryCardProps {
  createdAt?: string;
  documentId?: number;
  id?: number;
  name?: string;
  isTemplate: boolean;
  updatedBy?: string;
}

export function VersionHistoryCard({
  updatedBy,
  createdAt,
  id,
  name,
  documentId,
  isTemplate,
}: VersionHistoryCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType>('restore');
  const [modalData, setModalData] = useState({});

  const openModal = (data: { id?: number | undefined; name?: string; documentId?: number }) => {
    setModalData({ ...data, isVersion: true, isTemplate });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const modalProps = {
    onClose: closeModal,
    modalData: modalData,
  };

  const modalHandler = () => {
    switch (modalType) {
      case 'restore':
        return <ModalFactory type='restore' props={modalProps} />;

      case 'rename':
        return <ModalFactory type='versionName' props={modalProps} />;

      case 'duplicate':
        return <ModalFactory type='duplicate' props={modalProps} />;

      default:
        return null;
    }
  };

  return (
    <Fragment>
      {isModalOpen && modalHandler()}
      <Box className={styles.container}>
        <Box className={styles.info}>
          <Typography fontSize={'14px'} fontWeight={500}>
            {name || createdAt}
          </Typography>
          <Typography fontSize={'12px'} fontWeight={400}>
            {updatedBy}
          </Typography>
        </Box>
        <Box className={styles.moreIcon}>
          <MenuButton
            tooltipLabel='More Actions'
            buttonStyles={{
              padding: '0',
              minWidth: '40px',
              ':hover': {
                backgroundColor: colorPalette.backgroundWhite,
              },
            }}
            options={[
              {
                item: (
                  <Grid container justifyContent='flex-start' gap={1} width='264px'>
                    <VersionRestoreIcon /> Restore this version
                  </Grid>
                ),
                handler: () => {
                  setModalType!('restore');
                  openModal({ documentId, id });
                },
              },
              {
                item: (
                  <Grid container justifyContent='flex-start' gap={1} width='264px'>
                    <VersionNameIcon /> Name this version
                  </Grid>
                ),
                handler: () => {
                  setModalType!('rename');
                  openModal({ name: name ?? '', id });
                },
              },
              {
                item: (
                  <Grid container justifyContent='flex-start' gap={1} width='264px'>
                    <CopyIcon /> Make a copy
                  </Grid>
                ),
                handler: () => {
                  setModalType!('duplicate');
                  openModal({ name: name ?? '', id, documentId });
                },
              },
            ]}
          >
            <IconButton aria-label='more-actions'>
              <MoreVert color='primary' />
            </IconButton>
          </MenuButton>
        </Box>
      </Box>
    </Fragment>
  );
}

export default VersionHistoryCard;
